// extracted by mini-css-extract-plugin
export default {"active":"Sidebar_active__WTynD","inactive":"Sidebar_inactive__AZ8fZ","navIcon":"Sidebar_navIcon__kiqgA","navBtn":"Sidebar_navBtn__9uxdg"};